import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { nextPageRoute } from "../utils/modules";
import ImageLoader from "./ImageLoader";

const ImageButton = ({
  image,
  buttonText,
  backgroundStyle,
  buttonClasses,
  navigateTo,
  highlightButton,
  imageStyle,
  imagesToPreload,
  placeHolderImage,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleNavigate = () => {
    nextPageRoute(navigate, navigateTo, dispatch, imagesToPreload);
  };

  return (
    <button
      tabIndex="0"
      onClick={handleNavigate}
      className={`p-0 btn d-flex flex-column object-fit-contain link-underline link-underline-opacity-0  align-items-center justify-content-center ${highlightButton}`}
      style={{ width: "45%", ...backgroundStyle, minHeight: "150px" }}
    >
      <ImageLoader
        src={image}
        placeHolderImage={placeHolderImage}
        alt="Male"
        className="object-fit-contain"
        style={imageStyle}
        width={"100%"}
      />
      <div
        className={`${
          buttonClasses
            ? buttonClasses + " fw-semibold"
            : "btn btn-primary py-2 w-100 fw-semibold"
        }`}
      >
        {buttonText}
      </div>
    </button>
  );
};

export default ImageButton;
